import * as React from 'react'
import { useRef } from 'react'
import styled from 'styled-components'
import useScript from './useScript'

const Root = styled.div`
  width: 256px;
  margin: 0 auto;
`

export interface GoogleLoginResponse {
  clientId: string
  credentials: string
  select_by: string
}

interface GoogleLoginProps {
  onGoogleSignIn: (res: GoogleLoginResponse) => void
}

/**
 * See https://developers.google.com/identity/gsi/web/guides/display-button#button_rendering
 */
const GoogleLogin = (props: GoogleLoginProps) => {
  const { onGoogleSignIn } = props

  const googleSignInButton = useRef(null)

  useScript('https://accounts.google.com/gsi/client', () => {
    google.accounts.id.initialize({
      client_id: '672780895951-cu4kv06fbt03vhi9f5gms308kmdj9s7i.apps.googleusercontent.com',
      callback: onGoogleSignIn,
    })
    google.accounts.id.renderButton(googleSignInButton.current, { type: 'standard', width: 256 })
    google.accounts.id.prompt()
  })

  return <Root ref={googleSignInButton} />
}

export default GoogleLogin
